import { handleActions } from '../../helpers/immer';
import * as action from '../../actions/Notifications';

const initialValue = {
  loading: false,
  items: [],
};

export const notifications = handleActions(
  {
    [action.notificationsLoading]: (draft, { payload }) => {
      draft.loading = payload;
    },
    [action.setNotifications]: (draft, { payload }) => {
      draft.items = Array.isArray(payload) ? payload : [];
    },
  },
  initialValue
);
